import { render, staticRenderFns } from "./PlanterIndex.vue?vue&type=template&id=1d5c10da&scoped=true&"
import script from "./PlanterIndex.vue?vue&type=script&lang=js&"
export * from "./PlanterIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5c10da",
  null
  
)

export default component.exports